var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{'released':_vm.deck.released,'hovered':_vm.hovered},'booster-miniature']},[_c('div',{staticClass:"booster"},[_c('img',{staticClass:"booster-image",attrs:{"src":_vm.deck.booster,"alt":_vm.deck.title}}),_vm._m(0),_c('div',{staticClass:"highlight"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holo-wrapper"},[_c('div',{staticClass:"holo"}),_c('div',{staticClass:"holo-after"})])
}]

export { render, staticRenderFns }